export const FILTER_MAX_FILTERS = 6;

export const FILTER_DEFAULT_FILTERS = 1;

export const FILTER_CONTROLS = ['multiple', 'single'] as const;
export type FilterControl = (typeof FILTER_CONTROLS)[number];
